import axiosIns from "@/libs/axios";

export function requestLoadDashboard() {
  return axiosIns.post(`/admin/dashboard/`, {});
}

export function requestLoadCompassionDashboard() {
  return axiosIns.post(`/compassion/admin/dashboard`, {});
}
